(function (window) {
  'use strict';

  const modalForm = document.querySelector('.modal--reserve-in-store');
  const storeDetailsLink = document.querySelector('.zip-geolocate-result__details-link');
  const storeBackLink = document.querySelector('.zip-geolocate-result__back-link');

  const modalCard = document.querySelector('.card--reserve-in-store');
  const modalCardClass = 'js-card-reserve-in-store--detail';

  const modalInnerOverlay = document.querySelector('.modal-wrapper--reserve-in-store .js-modal__inner-overlay');

  const buttonZipGeolocate = document.querySelector('.zip-geolocate--zip');
  const inputZipGeolocate = document.querySelector('.zip-geolocate__input');

  const startView = document.querySelector('#modal-form--search-views--start');
  const noResultsView = document.querySelector('#modal-form--search-views--no-results');
  const storeResultsView = document.querySelector('#modal-form--search-views--store-results');
  const searchErrorView = document.querySelector('#modal-form--search-views--error');

  const searchView = document.querySelector('#modal-form--search');
  const formView = document.querySelector('#modal-form--form');
  const confirmationView = document.querySelector('#modal-form--confirmation');
  const errorView = document.querySelector('#modal-form--error');

  const storeResults = document.querySelector('.reserve-in-store--store-results');
  const changeStoreButton = document.querySelector('.reserve-in-store--change-store-button');
  const reserveButton = document.querySelector('.reserve-variation--button');

  const card = document.querySelector('.card--reserve-in-store');
  let variants = null;

  if(card !== null) {
    variants = card.querySelectorAll('.js-card-variant');
  }

  function toggleStoreDetail(e) {
    modalForm.classList.toggle('js-form-store-info');

    if(modalForm.classList.contains('js-form-store-info')) {
      changeStoreButton.addEventListener('click', toggleStoreDetail);
    } else {
      changeStoreButton.removeEventListener('click', toggleStoreDetail);
    }

    e.preventDefault();
  }

  function toggleCardDetail(e) {
    const modalCardParent = document.querySelector('.js-card.card--reserve-in-store').closest('.modal--reserve-in-store');

    if (modalCardParent) {
      modalCardParent.classList.toggle(modalCardClass);

      for(let i = 0; i < variants.length; i++) {
        if(modalCardParent.classList.contains(modalCardClass)) {
          variants[i].addEventListener('click', toggleCardDetail);
        } else {
          variants[i].removeEventListener('click', toggleCardDetail);
        }
      }
    }

    e.preventDefault();
  }

  function toggleInnerOverlay(e) {
    const modalInnerOverlaySpinner = modalInnerOverlay.querySelector('.icon--spinner');

    // Toggle spinner icon, overlay and event listeners for toggling visibility
    if(e.type === 'hideOverlay') {
      if(modalInnerOverlaySpinner) {
        const svgClass = modalInnerOverlaySpinner.getAttribute('class').replace(/js-show/, '');
        modalInnerOverlaySpinner.setAttribute('class', svgClass);
      }
      modalInnerOverlay.classList.add('js-hidden');
      modalInnerOverlay.addEventListener('showOverlay', toggleInnerOverlay, {once: true});
    } else {
      if(modalInnerOverlaySpinner) {
        const svgClass = modalInnerOverlaySpinner.getAttribute('class') + ' js-show';
        modalInnerOverlaySpinner.setAttribute('class', svgClass);
      }
      modalInnerOverlay.classList.remove('js-hidden');
      modalInnerOverlay.addEventListener('hideOverlay', toggleInnerOverlay, {once: true});
    }
  }

  function showInnerOverlay() {
    modalInnerOverlay.dispatchEvent(new CustomEvent('showOverlay'));
  }

  function hideInnerOverlay() {
    modalInnerOverlay.dispatchEvent(new CustomEvent('hideOverlay'));
  }

  function activateView(view, callback = handleViewActivated) {
    view.addEventListener('viewActivated', callback, {once: true});
    view.dispatchEvent(new CustomEvent('activateView'));
  }

  function handleViewActivated(e) {
    hideInnerOverlay();
  }

  function changeStore(e) {
    showInnerOverlay();

    card.dispatchEvent(new CustomEvent('deselectVariant'));

    activateView(searchView);
  }

  function updateStoreDetails(storeName, storeDistance, storeAddress, storePrescription) {
    formView.querySelector('.zip-geolocate-result__name').textContent = storeName;
    formView.querySelector('.zip-geolocate-result__distance').textContent = storeDistance;
    formView.querySelector('.zip-geolocate-result__address').textContent = storeAddress;

    if(storePrescription) {
      formView.querySelector('.zip-geolocate-result__type').classList.remove('js-hidden');
    } else {
      formView.querySelector('.zip-geolocate-result__type').classList.add('js-hidden');
    }

    confirmationView.querySelector('.zip-geolocate-result__name').textContent = storeName;
    confirmationView.querySelector('.zip-geolocate-result__distance').textContent = storeDistance;
    confirmationView.querySelector('.zip-geolocate-result__address').textContent = storeAddress;

    if(storePrescription) {
      confirmationView.querySelector('.zip-geolocate-result__type').classList.remove('js-hidden');
    } else {
      confirmationView.querySelector('.zip-geolocate-result__type').classList.add('js-hidden');
    }
  }

  function selectStore(e) {
    showInnerOverlay();

    const store = e.target.closest('.zip-geolocate__result');
    const storeName = store.getAttribute('data-store-name');
    const storeDistance = store.getAttribute('data-store-distance');
    const storeAddress = store.getAttribute('data-store-address');
    const storePrescription = store.getAttribute('data-store-prescription') === "true"  ;

    // Store the selected location details on the tradeAppApi object
    window.tradeAppApi.locationId = parseInt(store.getAttribute('data-store-id'));
    window.tradeAppApi.locationName = store.getAttribute('data-store-name');
    window.tradeAppApi.locationAddress = store.getAttribute('data-store-address');
    updateStoreDetails(storeName, storeDistance, storeAddress, storePrescription);

    card.dispatchEvent(new CustomEvent('selectVariant'));

    activateView(formView);

    e.preventDefault();
  }

  function setSearchResultsSummary(resultsNum, zipCode) {
    storeResultsView.querySelector('.reserve-in-store__results-found--results').textContent = resultsNum + "";
    storeResultsView.querySelector('.reserve-in-store__results-found--zip').textContent = zipCode;
  }

  function emptyResultsContainer() {
    while (storeResults.querySelector('.zip-geolocate__result')) {
      storeResults.removeChild(storeResults.querySelector('.zip-geolocate__result'));
    }
  }

  function createResultContainer(store) {
    const result = document.createElement('div');

    // Add zip-geolocate__result class
    result.classList.add('zip-geolocate__result');

    // Set result attributes
    result.setAttribute('data-store-id', store.locationId);
    result.setAttribute('data-store-name', store.name);
    result.setAttribute('data-store-distance', store.distance);
    result.setAttribute('data-store-distance-unit', store.distanceUnit);
    result.setAttribute('data-store-address', store.address);
    result.setAttribute('data-store-latitude', store.hasOwnProperty('geoLocation') && store.geoLocation.hasOwnProperty('coordinates') ? store.geoLocation.coordinates[0] : null);
    result.setAttribute('data-store-longitude', store.hasOwnProperty('geoLocation') && store.geoLocation.hasOwnProperty('coordinates') ? store.geoLocation.coordinates[1] : null);
    result.setAttribute('data-store-postcode', store.hasOwnProperty('zipCode') ? store.zipCode : null);
    result.setAttribute('data-store-prescription', store.hasOwnProperty('prescriptionRetailer') ? store.prescriptionRetailer : false);

    // Append result summary
    result.appendChild(createResultSummary(store.name, store.distance, store.distanceUnit));

    // Append result address
    result.appendChild(createResultAddress(store.address));

    // Append result prescription label
    if(store.hasOwnProperty('prescriptionRetailer') && store.prescriptionRetailer) {
      result.appendChild(createResultPrescriptionLabel(window.ris_i18n.prescription_retailer));
    }

    return result;
  }

  function createResultSummary(storeName, storeDistance, distanceUnit) {
    const summary = document.createElement('div');
    summary.classList.add('zip-geolocate-result__summary');
    summary.classList.add('zip-geolocate-result__details');

    // Append store name
    summary.appendChild(createResultName(storeName));

    // Append store distance
    summary.appendChild(createResultDistance(storeDistance, distanceUnit));

    return summary;
  }

  function createResultName(storeName) {
    const name = document.createElement('span');

    name.classList.add('zip-geolocate-result__name');
    name.textContent = storeName;
    return name
  }

  function createResultDistance(storeDistance, distanceUnit) {
    const distance = document.createElement('span');

    distance.classList.add('zip-geolocate-result__distance');
    distance.textContent = `${storeDistance} ${distanceUnit}`;

    return distance;
  }

  function createResultAddress(storeAddress) {
    const address = document.createElement('span');

    address.classList.add('zip-geolocate-result__address');
    address.classList.add('zip-geolocate-result__details');;
    address.textContent = storeAddress;

    return address;
  }

  function createResultPrescriptionLabel(prescriptionLabel) {
    const prescription = document.createElement('span');

    prescription.classList.add('zip-geolocate-result__type');
    prescription.classList.add('zip-geolocate-result__details');;
    prescription.textContent = prescriptionLabel;

    return prescription;
  }

  function populateStoreResults(response) {
    if(response.data.length === 0) { // If no results are available
      // Activate no-results view
      activateView(noResultsView);
    } else { // Otherwise
      // Populate search recap notice
      setSearchResultsSummary(response.data.length, window.tradeAppApi.zipCode);

      // Empty results container
      emptyResultsContainer();

      // Populate results container
      for (let i = 0; i < response.data.length; i++) {
        storeResults.appendChild(createResultContainer(response.data[i]));
      }

      // Activate store results view
      activateView(storeResultsView);
    }
  }

  function handleStoreListRequest(e) {
    showInnerOverlay();

    window.tradeAppApi.sku = document.querySelector('.card--reserve-in-store .js-card-variant--active').getAttribute('data-id');
    window.tradeAppApi.zipCode = e.detail.zip;

    if(window.tradeAppApi._demo === false) {
      let selectedVariant = null;
      for(let i = 0; i < window.tradeAppApiConfig.product.variants.length; i++) {
        if(window.tradeAppApiConfig.product.variants[i].sku === window.tradeAppApi.sku) {
          selectedVariant = window.tradeAppApiConfig.product.variants[i];
          break;
        }
      }
      window.tradeAppApi.variation = {
        category: window.tradeAppApiConfig.product.category,
        style: window.tradeAppApiConfig.product.style,
        frame: selectedVariant.frame,
        lens: selectedVariant.lens,
        image: selectedVariant.image,
        url: window.tradeAppApiConfig.product.url
      };
    }

    window.tradeAppApi.getLocations(populateStoreResults, handleSearchError);
  }

  function handleVariantSwitch(e) {
    buttonZipGeolocate.click();
  }

  function activateVariantSwitch(e) {
    for(let i = 0; i < variants.length; i++) {
      variants[i].addEventListener('click', handleVariantSwitch);
    }
  }

  function handleSearchError(response) {
    activateView(searchErrorView);
  }

  function deactivateVariantSwitch(e) {
    for(let i = 0; i < variants.length; i++) {
      variants[i].removeEventListener('click', handleVariantSwitch);
    }
  }

  function switchToStartView(e) {
    showInnerOverlay();
    activateView(startView);
  }

  function setFieldError(input, message) {
    const formItem = input.closest('.form-item');
    let inputError = formItem.querySelector('span.input-error');

    if(!inputError) {
      inputError = document.createElement('span');
      inputError.classList.add('input-error');
      inputError.classList.add('js-hidden');
      formItem.appendChild(inputError);
    }

    inputError.textContent = message;
    inputError.classList.remove('js-hidden');
    formItem.classList.add('form-item--error');
  }

  function unsetFieldError(e) {
    const input = e.currentTarget;
    const formItem = input.closest('.form-item');
    const inputError = formItem.querySelector('span.input-error') || Array.prototype.filter.call(formItem.parentNode.children, el => el.classList.contains('input-error'))[0];

    if(inputError) {
      inputError.classList.add('js-hidden');
    }

    formItem.classList.remove('form-item--error');
  }

  function validateRequiredField(field) {
    if(!field.value || field.value.trim() === "") {
      setFieldError(field, window.ris_i18n.required_field);
      field.addEventListener('input', unsetFieldError, {once: true});
      changeStoreButton.addEventListener('click', () => { unsetFieldError({currentTarget: field}); }, {once: true});
      return false;
    }

    return true;
  }

  function validatePersonName(field) {
    if(! /^[A-z\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1 \'\+\-\.]{1,100}$/i.test(field.value.trim())) {
      setFieldError(field, window.ris_i18n.invalid_name);
      field.addEventListener('input', unsetFieldError, {once: true});
      changeStoreButton.addEventListener('click', () => { unsetFieldError({currentTarget: field}); }, {once: true});
      return false;
    }

    return true;
  }

  function validateEmailAddress(field) {
    if(! /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(field.value.trim())) {
      setFieldError(field, window.ris_i18n.invalid_email_address);
      field.addEventListener('input', unsetFieldError, {once: true});
      changeStoreButton.addEventListener('click', () => { unsetFieldError({currentTarget: field}); }, {once: true});
      return false;
    }

    return true;
  }

  function validatePhoneNumber(field) {
    if(! /^[0-9+ ()-]*$/i.test(field.value.trim())) {
      setFieldError(field, window.ris_i18n.invalid_phone_number);
      field.addEventListener('input', unsetFieldError, {once: true});
      changeStoreButton.addEventListener('click', () => { unsetFieldError({currentTarget: field}); }, {once: true});
      return false;
    }

    return true;
  }

  function updateConfirmationDetails(firstName, lastName, emailAddress) {
    confirmationView.querySelector('.block--request-received').innerHTML = confirmationView.querySelector('.block--request-received').innerHTML.replace('{{reserve--first-name}}', firstName)
      .replace('{{reserve--last-name}}', lastName);
    confirmationView.querySelector('.block--request-store-confirmation').innerHTML = confirmationView.querySelector('.block--request-store-confirmation').innerHTML.replace('{{reserve--email-address}}', emailAddress);
  }

  function resetModalViews(modal) {
    if(modal.action === "close" && modal.id == 'reserve-in-store') {
      const viewsWrappers = document.querySelectorAll(`#${modal.id} .js-views-wrapper`);
      const modalFormForm = modalForm.querySelector('form');

      // Reset card
      card.dispatchEvent(new CustomEvent('resetVariant'));

      // Reset all views
      for(let i = 0; i < viewsWrappers.length; i++) {
        viewsWrappers[i].dispatchEvent(new CustomEvent('resetView'));
      }

      // Reset form
      modalFormForm.dispatchEvent(new CustomEvent('reset'));

      // Reset errors
      const inputFields = modalFormForm.querySelectorAll('input');
      for(let i = 0; i < inputFields.length; i++) {
        unsetFieldError({currentTarget: inputFields[i]});
      }

      // Reset Placeholders
      const dataContents = modalFormForm.querySelectorAll('[data-content]');
      for(let i = 0; i < dataContents.length; i++) {
        dataContents[i].innerHTML = atob(dataContents[i].getAttribute('data-content'));
      }

      // Reset Variant Switcher
      componentEvents.on('modal-change', setInitialVariant);
      modalForm.classList.remove('js-modal--reserve-in-store-initiated');

      // Deactivate trigger on variant switching
      deactivateVariantSwitch();
      buttonZipGeolocate.addEventListener('zip', activateVariantSwitch, {once: true});

      // Enable initial variant detection
      componentEvents.on('modal-change', setInitialVariant);
    }
  }

  function validateReserveForm(e) {
    const reserveFirstName = formView.querySelector('#reserve-first-name');
    const reserveLastName = formView.querySelector('#reserve-last-name');
    const reserveEmailAddress = formView.querySelector('#reserve-email-address');
    const reservePhoneNumber = formView.querySelector('#reserve-phone-number');
    const reserveSubscribe = formView.querySelector('#reserve-receive-updates');
    let valid = true;

    valid = validateRequiredField(reserveFirstName) && validatePersonName(reserveFirstName) && valid;
    valid = validateRequiredField(reserveLastName) && validatePersonName(reserveLastName) && valid;
    valid = validateRequiredField(reserveEmailAddress) && validateEmailAddress(reserveEmailAddress) && valid;
    valid = validateRequiredField(reservePhoneNumber) && validatePhoneNumber(reservePhoneNumber) && valid;

    if(valid) {
      showInnerOverlay();

      window.tradeAppApi.customer = {
        firstName: reserveFirstName.value.trim(),
        lastName: reserveLastName.value.trim(),
        email: reserveEmailAddress.value.trim(),
        phone: reservePhoneNumber.value.trim(),
        subscribe: false || reserveSubscribe.checked
      };

      window.tradeAppApi.createOrder(confirmReservation, handleReservationError);
    }
  }

  function handleReservationError(response) {
    activateView(errorView);
  }

  function confirmReservation(response) {
    updateConfirmationDetails(window.tradeAppApi.customer.firstName, window.tradeAppApi.customer.lastName, window.tradeAppApi.customer.email);

    activateView(confirmationView, evt => {
      card.dispatchEvent(new CustomEvent('confirmVariant'));
      handleViewActivated(evt);
    });
  }

  function setInitialVariant(modal) {
    if(modal.action === "open" && modal.id === 'reserve-in-store') {
      if (!modalForm.classList.contains('js-modal--reserve-in-store-initiated')) {
        const pdpVariant = document.querySelector('.js-product-detail-variant--active');
        card.querySelector(`.js-card-variant[data-id="${pdpVariant.getAttribute('data-id')}"]`).click();

        componentEvents.off('modal-change', setInitialVariant);
        modalForm.classList.add('js-modal--reserve-in-store-initiated');
      }
    }
  }

  function init() {
    if (storeDetailsLink) {
      storeDetailsLink.addEventListener('click', toggleStoreDetail);
    }

    if (storeBackLink) {
      storeBackLink.addEventListener('click', toggleStoreDetail);
    }

    if (modalCard) {
      const cardDetailLink = modalCard.querySelector('.card__link');

      cardDetailLink.addEventListener('click', toggleCardDetail);
    }

    if(modalInnerOverlay) {
      modalInnerOverlay.addEventListener('showOverlay', toggleInnerOverlay, {once: true});
    }

    if(buttonZipGeolocate) {
      buttonZipGeolocate.addEventListener('zip', handleStoreListRequest);
      buttonZipGeolocate.addEventListener('zip', activateVariantSwitch, {once: true});
      buttonZipGeolocate.addEventListener('zip-error', switchToStartView);
    }

    if(changeStoreButton) {
      changeStoreButton.addEventListener('click', changeStore);
    }

    if(reserveButton) {
      reserveButton.addEventListener('click', validateReserveForm);
    }

    componentEvents.on('modal-change', setInitialVariant);
    componentEvents.on('modal-change', resetModalViews);

    // Create Reserve in Store validation object if not already defined.
    window.ris_i18n = window.ris_i18n || {};

    // Add validation parameters for Reserve in Store.
    if(!window.ris_i18n.hasOwnProperty('empty_zip_code') || window.ris_i18n.empty_zip_code === '') {
      window.ris_i18n.empty_zip_code = "Please enter a Zip code.";
    }

    if(!window.ris_i18n.hasOwnProperty('invalid_zip_code') || window.ris_i18n.invalid_zip_code === '') {
      window.ris_i18n.invalid_zip_code = "Zip code incorrect. Please verify.";
    }

    if(!window.ris_i18n.hasOwnProperty('zip_code_regex')) {
      window.ris_i18n.zip_code_regex = /^[0-9A-Za-z \-]{5,10}$/;
    }

    if(!window.ris_i18n.hasOwnProperty('prescription_retailer') || window.ris_i18n.prescription_retailer === '') {
      window.ris_i18n.prescription_retailer = "Prescription Retailer";
    }

    if(!window.ris_i18n.hasOwnProperty('reserve_now') || window.ris_i18n.reserve_now === '') {
      window.ris_i18n.reserve_now = "Reserve Now";
    }

    if(!window.ris_i18n.hasOwnProperty('required_field') || window.ris_i18n.required_field === '') {
      window.ris_i18n.required_field = "Required field.";
    }

    if(!window.ris_i18n.hasOwnProperty('invalid_name') || window.ris_i18n.invalid_name === '') {
      window.ris_i18n.invalid_name = "Invalid name.";
    }

    if(!window.ris_i18n.hasOwnProperty('invalid_email_address') || window.ris_i18n.invalid_email_address === '') {
      window.ris_i18n.invalid_email_address = "Invalid email address.";
    }

    if(!window.ris_i18n.hasOwnProperty('invalid_phone_number') || window.ris_i18n.invalid_phone_number === '') {
      window.ris_i18n.invalid_phone_number = "Invalid phone number.";
    }
  }

  init();

})(this);
